// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".portal-green-bg[data-v-1552ac82]{height:59px;color:#fff}thead[data-v-1552ac82]{background-color:#fafafa;color:#9faaaf}tbody[data-v-1552ac82]{color:#00475a;font-weight:bolder}.portal-deep-blue-bg[data-v-1552ac82]{height:59px;color:#fff;text-transform:uppercase}.km[data-v-1552ac82]{color:#00475a!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
